import { IPhoneNumber } from '../../../../../../shared/redux/reducers';
import { getPhone } from '../../../../../../shared/utils';

export const isPhonesUnique = (phone0: IPhoneNumber | undefined, phone1: IPhoneNumber | undefined): boolean => {
  if (!phone0 || !phone1) {
    return true;
  }

  return getPhone(phone0) !== getPhone(phone1);
};
